// extracted by mini-css-extract-plugin
export default {"sidebar":"styles_sidebar__5jBK6"};